(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mix-and-match-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mix-match-gallery')) {
    customElements.define('mix-match-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.slides = Array.from(this.querySelectorAll('[data-mix-slide]'));
        this.thumbs = Array.from(this.querySelectorAll('[data-mix-thumb]'));
        this.index = 0;
        this.thumbs.forEach((button, index) => button.addEventListener('click', () => this.show(index)));
        this.querySelector('[data-mix-prev]')?.addEventListener('click', () => this.show(this.index - 1));
        this.querySelector('[data-mix-next]')?.addEventListener('click', () => this.show(this.index + 1));
        this.addEventListener('keydown', (event) => {
          if (!event.target.closest('[data-mix-thumb]')) return;
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          this.thumbs[this.index]?.focus();
        });
        let touchStart;
        const mainImage = this.querySelector('.pdp-bundle__main-image');
        mainImage?.addEventListener('touchstart', event => { if (event.touches.length === 1) touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY }; }, { passive: true });
        mainImage?.addEventListener('touchend', event => {
          if (!touchStart || !event.changedTouches.length) return;
          const dx = event.changedTouches[0].clientX - touchStart.x;
          const dy = event.changedTouches[0].clientY - touchStart.y;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) this.show(this.index + (dx < 0 ? 1 : -1));
          touchStart = null;
        }, { passive: true });
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.slides.findIndex(slide => slide.dataset.mixSlide === event.detail.blockId);
          if (index >= 0) this.show(index);
        });
      }
      show(index) {
        if (!this.slides.length) return;
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
        this.thumbs.forEach((button, i) => {
          button.classList.toggle('is-active', i === this.index);
          button.setAttribute('aria-pressed', String(i === this.index));
        });
        this.thumbs[this.index]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    });
  }

  if (!customElements.get('mix-match-facts')) {
    customElements.define('mix-match-facts', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const select = this.querySelector('select');
        const panels = Array.from(this.querySelectorAll('[data-facts-panel]'));
        if (!select || !panels.length) return;
        const show = () => panels.forEach(panel => { panel.hidden = panel.dataset.factsPanel !== select.value; });
        select.addEventListener('change', show);
        this.querySelector('[data-facts-picker]').hidden = false;
        this.classList.add('is-ready');
        show();
        this.addEventListener('shopify:block:select', event => { if (panels.some(panel => panel.dataset.factsPanel === event.detail.blockId)) { select.value = event.detail.blockId; show(); } });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;
    


    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url).then(response => response.text()).then(text => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector('.product-recommendations');

      if (recommendations && recommendations.innerHTML.trim().length) {
        productRecommendationsSection.innerHTML = recommendations.innerHTML;
      }
    }).catch(e => {
      console.error(e);
    });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
